/*
 * @Author:
 * @LastEditTime: 2023-8-25 17:51:52
 * @Description:  弹窗滚动后隐藏select溢出内容
 */
import Vue from 'vue'
import _ from 'lodash'

// v-hideSelect: 弹窗滚动后隐藏select溢出
Vue.directive('hideSelect', {
  inserted(el) {
    Vue.nextTick(() => {
      const scrollContainer = el.querySelector('.el-dialog__body')
      const selectEls = scrollContainer.querySelectorAll('.el-select-dropdown')

      if (selectEls.length > 0) {
        const handleScroll = _.throttle(() => {
          _.forEach(selectEls, (select) => {
            select.style.display = 'none'
          })
        }, 100)
        scrollContainer.addEventListener('scroll', handleScroll)
        // 储存处理函数 用于移除
        el._scrollHandler = handleScroll
      }
    })
  },
  unbind(el) {
    const scrollContainer = el.querySelector('.el-dialog__body')
    const handleScroll = el._scrollHandler
    if (scrollContainer && handleScroll) {
      scrollContainer.removeEventListener('scroll', handleScroll)
    }
  },
})
